import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getLanguagesStart } from '../../../../store/redux-slices/languages'
import { useDidMountEffect } from '../../../../utils/useDidMountEffect'

const useLanguages = () => {
  const dispatch = useDispatch()
  const { languages, loading } = useSelector(state => state?.languages)
  const [limit, setLimit] = useState(15)
  const [pageNo, setPageNo] = useState(1)
  const [name, setName] = useState('')
  const totalPages = Math.ceil(languages?.count / limit)
  const isInitialRender = useDidMountEffect()

  useEffect(() => {
    dispatch(getLanguagesStart({ limit, pageNo, name }))
  }, [limit, pageNo])

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (pageNo === 1) {
          dispatch(getLanguagesStart({ limit, pageNo, name }))
        } else {
          setPageNo(1)
        }
      }
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [name])

  useEffect(() => {
    !isInitialRender && dispatch(getLanguagesStart({ limit, pageNo, name }))
  }, [pageNo])

  useEffect(() => {
    setPageNo(1)
    dispatch(getLanguagesStart({ limit, pageNo, name }))
  }, [limit])

  return {
    loading,
    languages,
    limit,
    pageNo,
    totalPages,
    setPageNo,
    setLimit,
    name,
    setName
  }
}

export default useLanguages
